import { render, staticRenderFns } from "./chainPage3.vue?vue&type=template&id=74e61172&scoped=true"
import script from "./chainPage3.vue?vue&type=script&lang=js"
export * from "./chainPage3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74e61172",
  null
  
)

export default component.exports